import React from 'react';
import { useAuth } from '../lib/auth';

export default function AdminDashboard() {
  const { user } = useAuth(); 

  return (
    <div>
       <h2>Welcome, Admin {user?.email}!</h2>
        <p>This is your admin dashboard content area.</p>
        <div style={{ marginTop: '20px', padding: '15px', border: '1px solid #ccc', borderRadius: '5px' }}>
          <h3>API Health Check</h3>

        </div>
        {/* Add admin-specific widgets or information here */}
    </div>
  );
}
